import axios from "axios";
import { baseURLApi } from "./index"

const request = axios.create({
    baseURL: baseURLApi
})


export default request